import script from "./AbsenceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceItem.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceItem.vue?vue&type=style&index=0&id=c4abc942&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4abc942"]])

export default __exports__